(() => {
  'use strict';
  const initialized = new WeakSet();
  const start = () => {
    document.querySelectorAll('[data-member-explore-list]').forEach(feed => {
      if (initialized.has(feed)) return;
      initialized.add(feed);
      const cards = feed.querySelector('[data-member-explore-cards]');
      const pending = Array.from(feed.querySelectorAll('template[data-member-explore-card]'));
      const more = feed.querySelector('[data-member-explore-more]');
      const bar = feed.querySelector('[data-member-explore-auth]');
      const nav = document.querySelector('.neko-bottom-nav');
      const positionBar = () => {
        feed.style.setProperty('--nm-auth-offset', (nav?.getBoundingClientRect().height || 0) + 'px');
        feed.style.setProperty('--nm-auth-height', bar.getBoundingClientRect().height + 'px');
      };
      const layoutObserver = new ResizeObserver(positionBar);
      if (nav) layoutObserver.observe(nav);
      layoutObserver.observe(bar);
      positionBar();
      const maskReady = new WeakSet();
      const positionMask = box => {
        const secondRow = box.querySelectorAll('.kuji-prize-card')[3];
        const info = secondRow?.querySelector('.kuji-prize-info');
        const photo = secondRow?.querySelector('img');
        if (!info || !photo) return;
        const bounds = box.getBoundingClientRect();
        const image = photo.getBoundingClientRect();
        const cueHeight = box.querySelector('.nm-explore-card-login').getBoundingClientRect().height;
        const solidAt = Math.max(0, Math.min(info.getBoundingClientRect().top - bounds.top - 6, bounds.height - cueHeight - 4));
        const fadeAt = Math.max(0, Math.min(image.top - bounds.top + image.height * 0.25, solidAt - 24));
        box.style.setProperty('--nm-fade-top', fadeAt + 'px');
        box.style.setProperty('--nm-fade-span', (solidAt - fadeAt) + 'px');
      };
      const maskObserver = new ResizeObserver(entries => {
        entries.forEach(entry => positionMask(entry.target.closest('.nm-explore-native-square')));
      });
      const prepareMasks = () => {
        cards.querySelectorAll('.nm-explore-native-square').forEach(box => {
          if (maskReady.has(box)) return;
          maskReady.add(box);
          maskObserver.observe(box);
          const grid = box.querySelector('.kuji-prize-grid');
          if (grid) maskObserver.observe(grid);
          positionMask(box);
        });
      };
      let observer;
      const append = count => {
        pending.splice(0, count).forEach(template => {
          cards.appendChild(template.content.cloneNode(true));
          template.remove();
        });
        window.NekoMemberAccess?.decorate(cards);
        prepareMasks();
        if (!pending.length) {
          more.remove();
          observer?.disconnect();
        }
      };
      append(feed.hasAttribute('data-explore-editor') ? pending.length : Math.max(0, 3 - cards.querySelectorAll('.nm-explore-native-card').length));
      if (pending.length) {
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) append(3);
        }, { rootMargin: '400px' });
        observer.observe(more);
      }
    });
  };
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest('.nx-banner');
    if (block) block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  start();
  new MutationObserver(start).observe(document.body, { childList: true, subtree: true });
})();
